module.exports = __webpack_public_path__ + "static/Amelie_Brochu-b34b677fcbdbb72529f38a5663ba59f1.png";